var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "app-main-inner tracking-form",
      staticStyle: { display: "flex", "flex-direction": "column" }
    },
    [
      _c(
        "div",
        {
          staticClass: "app-main-inner-row",
          staticStyle: { "margin-left": "-32px !important" }
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "flex-direction": "row",
                width: "100%"
              }
            },
            [
              _c(
                "el-card",
                {
                  staticClass: "box-card",
                  staticStyle: { height: "100%", width: "400px" }
                },
                [
                  _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                    _c("span", [_vm._v(_vm._s(_vm.title))])
                  ]),
                  _c(
                    "el-form",
                    {
                      ref: "trackingForm",
                      staticStyle: { width: "100%" },
                      attrs: {
                        disabled: _vm.readOnly,
                        "label-position": "left",
                        "label-width": "90px"
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("Pricing.FeeIndex") } },
                        [
                          _c("el-input-number", {
                            attrs: { "controls-position": "right" },
                            model: {
                              value: _vm.trackingForm.level,
                              callback: function($$v) {
                                _vm.$set(_vm.trackingForm, "level", $$v)
                              },
                              expression: "trackingForm.level"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("CargoMsg.Cargo_Code") } },
                        [
                          _c("el-input", {
                            attrs: { disabled: _vm.isPlatformCode },
                            on: {
                              blur: function() {
                                return (_vm.trackingForm.code = _vm.trackingForm.code.trim())
                              }
                            },
                            model: {
                              value: _vm.trackingForm.code,
                              callback: function($$v) {
                                _vm.$set(_vm.trackingForm, "code", $$v)
                              },
                              expression: "trackingForm.code"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_ChineseNamed")
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { disabled: _vm.isPlatformCode },
                            on: {
                              blur: function() {
                                return (_vm.trackingForm.codeCname = _vm.trackingForm.codeCname.trim())
                              }
                            },
                            model: {
                              value: _vm.trackingForm.codeCname,
                              callback: function($$v) {
                                _vm.$set(_vm.trackingForm, "codeCname", $$v)
                              },
                              expression: "trackingForm.codeCname"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_EnglishNamed")
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { disabled: _vm.isPlatformCode },
                            on: {
                              blur: function() {
                                return (_vm.trackingForm.codeEname = _vm.trackingForm.codeEname.trim())
                              }
                            },
                            model: {
                              value: _vm.trackingForm.codeEname,
                              callback: function($$v) {
                                _vm.$set(_vm.trackingForm, "codeEname", $$v)
                              },
                              expression: "trackingForm.codeEname"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("CargoMsg.Cargo_NodeType") } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "input-w",
                              attrs: { clearable: false },
                              model: {
                                value: _vm.trackingForm.nodeType,
                                callback: function($$v) {
                                  _vm.$set(_vm.trackingForm, "nodeType", $$v)
                                },
                                expression: "trackingForm.nodeType"
                              }
                            },
                            _vm._l(_vm.$constantI18n("nodeType"), function(
                              item,
                              index
                            ) {
                              return _c("el-option", {
                                key: index,
                                attrs: { label: item.name, value: item.value }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-checkbox",
                            {
                              model: {
                                value: _vm.trackingForm.allowTriggerRollback,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.trackingForm,
                                    "allowTriggerRollback",
                                    $$v
                                  )
                                },
                                expression: "trackingForm.allowTriggerRollback"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "SystemMaintenance.AllowStatusToTriggerRollback"
                                  )
                                )
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("CargoMsg.Cargo_NodeType") } },
                        [
                          _c(
                            "el-checkbox",
                            {
                              model: {
                                value: _vm.trackingForm.published,
                                callback: function($$v) {
                                  _vm.$set(_vm.trackingForm, "published", $$v)
                                },
                                expression: "trackingForm.published"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("CargoMsg.Cargo_WhetherToDisclose")
                                )
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm.isNew || _vm.isEdit
                        ? [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "CargoMsg.Cargo_ApplicationScope"
                                  )
                                }
                              },
                              [
                                _c(
                                  "el-radio-group",
                                  {
                                    on: {
                                      change: _vm.onApplicationScopeChange
                                    },
                                    model: {
                                      value: _vm.trackingForm.applicationScope,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.trackingForm,
                                          "applicationScope",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "trackingForm.applicationScope"
                                    }
                                  },
                                  [
                                    _c(
                                      "el-radio",
                                      {
                                        staticStyle: { "margin-top": "7px" },
                                        attrs: { label: 0 }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.isNew
                                              ? _vm.$t(
                                                  "SystemMaintenance.AddOnlyCurrentTemplate"
                                                )
                                              : _vm.$t(
                                                  "SystemMaintenance.OnlyModifyCurrentTemplate"
                                                )
                                          )
                                        )
                                      ]
                                    ),
                                    _c(
                                      "el-radio",
                                      {
                                        staticStyle: { margin: "5px 0 7px 0" },
                                        attrs: { label: 1 }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.isNew
                                              ? _vm.$t(
                                                  "SystemMaintenance.AddOtherSameLobTempalte"
                                                )
                                              : _vm.$t(
                                                  "SystemMaintenance.ModifyTemplateContaneNode"
                                                )
                                          )
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm.isNew && _vm.trackingForm.applicationScope === 1
                              ? _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "SystemMaintenance.ApplicationTemplate"
                                      )
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        disabled: "",
                                        value: _vm.applicationTemplateLabel
                                      },
                                      nativeOn: {
                                        dblclick: function($event) {
                                          return _vm.showTemplateSelectDialog(
                                            $event
                                          )
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e()
                          ]
                        : _vm._e(),
                      _vm.isPlatform
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "CargoMsg.Cargo_QuicklyConfigureSettings"
                                )
                              }
                            },
                            [
                              _c(
                                "el-checkbox",
                                {
                                  model: {
                                    value: _vm.trackingForm.quickConfiguration,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.trackingForm,
                                        "quickConfiguration",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "trackingForm.quickConfiguration"
                                  }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "CargoMsg.Cargo_QuickConfigurationIsCheckedByDefault"
                                        )
                                      )
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("CargoMsg.Cargo_Remarks") } },
                        [
                          _c("el-input", {
                            attrs: { type: "textarea", rows: 3 },
                            model: {
                              value: _vm.trackingForm.remark,
                              callback: function($$v) {
                                _vm.$set(_vm.trackingForm, "remark", $$v)
                              },
                              expression: "trackingForm.remark"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    2
                  ),
                  _vm.trackingForm.uuid && !_vm.isPlatform
                    ? _c(
                        "el-form",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            "label-position": "left",
                            "label-width": "90px"
                          }
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "auto-width",
                              attrs: { "label-width": "0" }
                            },
                            [
                              _c(
                                "div",
                                { staticStyle: { flex: "1", display: "flex" } },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "el-form-item__label" },
                                    [_vm._v(_vm._s(_vm.$t("Menu.Icon")))]
                                  ),
                                  _c("i", {
                                    staticClass: "el-icon-warning",
                                    staticStyle: {
                                      color: "#1f75d5",
                                      "font-size": "16px",
                                      cursor: "pointer",
                                      "padding-right": "38px",
                                      "padding-top": "5px"
                                    },
                                    attrs: {
                                      title: _vm.$t(
                                        "CargoMsg.Cargo_TrackingIconTip"
                                      )
                                    }
                                  }),
                                  _c(
                                    "div",
                                    {
                                      style:
                                        _vm.currentCss +
                                        "width: 68px; height: 68px; border: 1px solid #dddfe6; border-radius: 2px; text-align:center; cursor: pointer;"
                                    },
                                    [
                                      !_vm.trackingForm.documentId
                                        ? _c(
                                            "cargo-el-upload",
                                            {
                                              staticStyle: {
                                                display: "inline-block",
                                                "padding-left": "5px",
                                                "padding-right": "5px"
                                              },
                                              attrs: {
                                                action:
                                                  _vm.URL.sys
                                                    .uploadTrackingIcon,
                                                "show-file-list": false,
                                                data: {
                                                  trackingUuid:
                                                    _vm.trackingForm.uuid
                                                },
                                                "before-upload":
                                                  _vm.beforeUpload,
                                                "on-progress":
                                                  _vm.handleProgress,
                                                "on-success": _vm.handleSuccess,
                                                "on-error": _vm.handleError,
                                                "list-type": "picture"
                                              }
                                            },
                                            [
                                              _c("img", {
                                                staticStyle: {
                                                  "margin-top": "23px"
                                                },
                                                attrs: {
                                                  src: _vm.currentIcon,
                                                  width: "22",
                                                  height: "22",
                                                  alt: ""
                                                }
                                              })
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm.trackingForm.documentId
                                        ? _c("img", {
                                            staticStyle: {
                                              "margin-top": "23px"
                                            },
                                            attrs: {
                                              src: _vm.currentIcon,
                                              width: "22",
                                              height: "22"
                                            },
                                            on: {
                                              mouseover: function($event) {
                                                return _vm.mouseoverIcon()
                                              },
                                              click: function($event) {
                                                return _vm.clickIcon()
                                              },
                                              mouseleave: function($event) {
                                                return _vm.mouseleaveIcon()
                                              }
                                            }
                                          })
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ]
                              )
                            ]
                          ),
                          _c("el-form-item", [
                            _c(
                              "span",
                              { staticStyle: { color: "#b1b4b4ff" } },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("CargoMsg.Cargo_TrackingTipTwo")
                                  )
                                )
                              ]
                            )
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isNew || _vm.isEdit
                    ? _c(
                        "el-form",
                        { attrs: { "label-width": "0" } },
                        [
                          _c("el-form-item", [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "line-height": "18px"
                                }
                              },
                              [
                                _c("i", {
                                  staticClass: "el-icon-warning",
                                  staticStyle: {
                                    color: "#E6A23C",
                                    "font-size": "14px",
                                    "margin-right": "5px"
                                  }
                                }),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "SystemMaintenance.SetNodeLimitTip"
                                      )
                                    )
                                  )
                                ])
                              ]
                            )
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form",
                    {
                      staticStyle: { "margin-top": "15px" },
                      attrs: { disabled: _vm.readOnly, "label-width": "0" }
                    },
                    [
                      _c("span", { staticClass: "title" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("SystemMaintenance.ToDoNodeRuleSettings")
                          )
                        )
                      ]),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-checkbox",
                            {
                              model: {
                                value: _vm.trackingForm.workTaskIgnoreMaster,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.trackingForm,
                                    "workTaskIgnoreMaster",
                                    $$v
                                  )
                                },
                                expression: "trackingForm.workTaskIgnoreMaster"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("SystemMaintenance.MainNotToDoTask")
                                )
                              )
                            ]
                          ),
                          _c(
                            "el-checkbox",
                            {
                              model: {
                                value: _vm.trackingForm.sopBoardNotShow,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.trackingForm,
                                    "sopBoardNotShow",
                                    $$v
                                  )
                                },
                                expression: "trackingForm.sopBoardNotShow"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "CargoMsg.Cargo_SOPPanelNodeNotDisplayed"
                                  )
                                )
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm.trackingTemplateForm.workTaskEnable || _vm.isPlatform
                ? _c(
                    "el-card",
                    {
                      staticClass: "box-card",
                      staticStyle: { width: "468px" }
                    },
                    [
                      _c(
                        "el-form",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            disabled: _vm.readOnly,
                            "label-position": "left",
                            "label-width": "0px"
                          }
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "title",
                              attrs: {
                                title: _vm.$t(
                                  "CargoMsg.Cargo_SetNodeResponsible"
                                )
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("CargoMsg.Cargo_SetNodeResponsible")
                                )
                              )
                            ]
                          ),
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "el-checkbox",
                                {
                                  on: {
                                    change: function($event) {
                                      return _vm.positionEnableChange()
                                    }
                                  },
                                  model: {
                                    value: _vm.positionEnable,
                                    callback: function($$v) {
                                      _vm.positionEnable = $$v
                                    },
                                    expression: "positionEnable"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "CargoMsg.AssignedWorkResponsibleForNode"
                                      )
                                    )
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            [
                              _c("cargo-advance-select", {
                                staticStyle: { width: "370px" },
                                attrs: {
                                  disabled: !_vm.positionEnable,
                                  multiple: "",
                                  "default-multiple-value":
                                    _vm.designatedPositions,
                                  filterable: "",
                                  "static-options": _vm.positionOptions,
                                  "tag-name": "chineseName",
                                  "tag-value": "code",
                                  "filter-tag-names": [
                                    "code",
                                    "chineseName",
                                    "englishName"
                                  ],
                                  "options-width": "230px"
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.designatedPositions = p.value || []
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.isPlatform,
                                  expression: "!isPlatform"
                                }
                              ],
                              attrs: { label: "" }
                            },
                            [
                              _c(
                                "el-checkbox",
                                {
                                  on: {
                                    change: function($event) {
                                      return _vm.personnelEnableChange()
                                    }
                                  },
                                  model: {
                                    value: _vm.personnelEnable,
                                    callback: function($$v) {
                                      _vm.personnelEnable = $$v
                                    },
                                    expression: "personnelEnable"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "CargoMsg.Cargo_DesignatedPersonnel"
                                      )
                                    )
                                  )
                                ]
                              ),
                              _c("cargo-advance-select", {
                                staticStyle: { width: "370px" },
                                attrs: {
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_User,
                                  fields: ["chineseName"],
                                  disabled: !_vm.personnelEnable,
                                  "callback-params": { key: "userId" },
                                  "callback-method-type": "obj",
                                  "tag-value": "userId",
                                  "tag-name": "chineseName",
                                  "filter-tag-names": ["chineseName"],
                                  "method-params": {
                                    pageSize: 1000000,
                                    active: true,
                                    hasRole: true
                                  },
                                  multiple: "",
                                  "default-multiple-value":
                                    _vm.designatedPersons,
                                  filterable: "",
                                  "options-width": "230px"
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.designatedPersons = p.value || []
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "title",
                              staticStyle: { "margin-top": "20px" },
                              attrs: {
                                title: _vm.$t("CargoMsg.Cargo_SetPreNode")
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("CargoMsg.Cargo_SetPreNode"))
                              )
                            ]
                          ),
                          _c(
                            "el-form-item",
                            { staticStyle: { "margin-left": "15px" } },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("CargoMsg.Cargo_SetPreNodeTips")
                                  )
                                ),
                                _c("i", {
                                  staticClass: "el-icon-circle-plus",
                                  staticStyle: {
                                    color: "#42b983",
                                    cursor: "pointer",
                                    position: "absolute",
                                    right: "35px",
                                    top: "5px",
                                    "font-size": "18px"
                                  },
                                  on: { click: _vm.addTrackingWtPreNode }
                                })
                              ])
                            ]
                          ),
                          _vm._l(_vm.trackingForm.trackingWtPreNodes, function(
                            trackingWtPreNode,
                            index
                          ) {
                            return _c(
                              "el-form-item",
                              {
                                key: index,
                                staticStyle: { "margin-left": "15px" }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "align-items": "center",
                                      "justify-content": "flex-start"
                                    }
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "170px" },
                                        attrs: { filterable: "" },
                                        on: {
                                          change: function($event) {
                                            return _vm.preTrackingChange(
                                              $event,
                                              trackingWtPreNode
                                            )
                                          }
                                        },
                                        model: {
                                          value:
                                            trackingWtPreNode.preTrackingUuid,
                                          callback: function($$v) {
                                            _vm.$set(
                                              trackingWtPreNode,
                                              "preTrackingUuid",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "trackingWtPreNode.preTrackingUuid"
                                        }
                                      },
                                      _vm._l(_vm.preTrackingOptions, function(
                                        item,
                                        index
                                      ) {
                                        return _c("el-option", {
                                          key: index,
                                          attrs: {
                                            label: _vm.isZh
                                              ? item.chineseName
                                              : item.englishName,
                                            value: item.uuid
                                          }
                                        })
                                      }),
                                      1
                                    ),
                                    _c("cargo-advance-select", {
                                      staticStyle: {
                                        "margin-left": "10px",
                                        width: "170px"
                                      },
                                      attrs: {
                                        filterable: "",
                                        clearable: "",
                                        multiple: "",
                                        "tag-value": "uuid",
                                        "static-options":
                                          trackingWtPreNode.trackingDetails,
                                        "default-multiple-value":
                                          trackingWtPreNode.preTrackingDetailUuids
                                      },
                                      on: {
                                        parentCallBack: function(p) {
                                          trackingWtPreNode.preTrackingDetailUuids =
                                            p.value
                                        }
                                      }
                                    }),
                                    _c("i", {
                                      staticClass: "el-icon-remove",
                                      staticStyle: {
                                        color: "#f56c6c",
                                        cursor: "pointer",
                                        position: "absolute",
                                        right: "35px",
                                        top: "5px",
                                        "font-size": "18px"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.deleteTrackingWtPreNode(
                                            index
                                          )
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          }),
                          _c(
                            "span",
                            {
                              staticClass: "title",
                              staticStyle: { "margin-top": "20px" },
                              attrs: {
                                title: _vm.$t(
                                  "CargoMsg.Cargo_HandlingPriorityMarkers"
                                )
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "CargoMsg.Cargo_HandlingPriorityMarkers"
                                  )
                                )
                              )
                            ]
                          ),
                          _c(
                            "div",
                            { staticStyle: { "margin-left": "15px" } },
                            [
                              _c(
                                "el-form-item",
                                [
                                  _c(
                                    "el-checkbox",
                                    {
                                      on: {
                                        change: function($event) {
                                          return _vm.priorityHighEnableChange()
                                        }
                                      },
                                      model: {
                                        value: _vm.priorityHighEnable,
                                        callback: function($$v) {
                                          _vm.priorityHighEnable = $$v
                                        },
                                        expression: "priorityHighEnable"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "CargoMsg.Cargo_HandlingPriorityMarkersHigh"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "CargoMsg.Cargo_ConditionalItem"
                                        ) + ": "
                                      )
                                    )
                                  ]),
                                  _c("cargo-advance-select", {
                                    staticStyle: {
                                      "margin-left": "10px",
                                      width: "296px",
                                      display: "inline-block"
                                    },
                                    attrs: {
                                      disabled: !_vm.priorityHighEnable,
                                      "default-value":
                                        _vm.trackingForm.trackingWtPriority
                                          .conditionFieldHigh,
                                      "static-options": _vm.priorityConditions,
                                      "tag-value": "code",
                                      filterable: "",
                                      "filter-type": "global",
                                      cache: false
                                    },
                                    on: {
                                      parentCallBack: function(p) {
                                        _vm.trackingForm.trackingWtPriority.conditionFieldHigh =
                                          p.value
                                      }
                                    }
                                  }),
                                  _c(
                                    "div",
                                    { staticStyle: { "margin-top": "10px" } },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          staticStyle: {
                                            width: "65px",
                                            "margin-right": "5px"
                                          },
                                          attrs: {
                                            disabled: !_vm.priorityHighEnable
                                          },
                                          model: {
                                            value:
                                              _vm.trackingForm
                                                .trackingWtPriority
                                                .triggerMethodHigh,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.trackingForm
                                                  .trackingWtPriority,
                                                "triggerMethodHigh",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "trackingForm.trackingWtPriority.triggerMethodHigh"
                                          }
                                        },
                                        [
                                          _c("el-option", {
                                            attrs: {
                                              value: 1,
                                              label: _vm.$t(
                                                "CargoMsg.Cargo_BringForward"
                                              )
                                            }
                                          }),
                                          _c("el-option", {
                                            attrs: {
                                              value: 2,
                                              label: _vm.$t(
                                                "CargoMsg.Cargo_Postpone"
                                              )
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c("el-input-number", {
                                        staticStyle: {
                                          width: "112px",
                                          "margin-left": "5px",
                                          "margin-right": "5px"
                                        },
                                        attrs: {
                                          disabled: !_vm.priorityHighEnable,
                                          type: "number",
                                          oninput:
                                            "value=value.replace(/[^\\d]/g,'')",
                                          step: 1,
                                          controls: false
                                        },
                                        model: {
                                          value:
                                            _vm.trackingForm.trackingWtPriority
                                              .hourHigh,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.trackingForm
                                                .trackingWtPriority,
                                              "hourHigh",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "trackingForm.trackingWtPriority.hourHigh"
                                        }
                                      }),
                                      _c("span", [
                                        _vm._v(_vm._s(_vm.$t("Pricing.Hour")))
                                      ]),
                                      _c("el-input-number", {
                                        staticStyle: {
                                          width: "112px",
                                          "margin-left": "5px",
                                          "margin-right": "5px"
                                        },
                                        attrs: {
                                          disabled: !_vm.priorityHighEnable,
                                          type: "number",
                                          min: 0,
                                          max: 59,
                                          step: 1,
                                          controls: false
                                        },
                                        model: {
                                          value:
                                            _vm.trackingForm.trackingWtPriority
                                              .minuteHigh,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.trackingForm
                                                .trackingWtPriority,
                                              "minuteHigh",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "trackingForm.trackingWtPriority.minuteHigh"
                                        }
                                      }),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.$t("SeaExport.Minute"))
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                [
                                  _c(
                                    "el-checkbox",
                                    {
                                      on: {
                                        change: function($event) {
                                          return _vm.priorityMediumEnableChange()
                                        }
                                      },
                                      model: {
                                        value: _vm.priorityMediumEnable,
                                        callback: function($$v) {
                                          _vm.priorityMediumEnable = $$v
                                        },
                                        expression: "priorityMediumEnable"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "CargoMsg.Cargo_HandlingPriorityMarkersMedium"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "CargoMsg.Cargo_ConditionalItem"
                                        ) + ": "
                                      )
                                    )
                                  ]),
                                  _c("cargo-advance-select", {
                                    staticStyle: {
                                      "margin-left": "10px",
                                      width: "296px",
                                      display: "inline-block"
                                    },
                                    attrs: {
                                      disabled: !_vm.priorityMediumEnable,
                                      "default-value":
                                        _vm.trackingForm.trackingWtPriority
                                          .conditionFieldMedium,
                                      "static-options": _vm.priorityConditions,
                                      "tag-value": "code",
                                      filterable: "",
                                      "filter-type": "global",
                                      cache: false
                                    },
                                    on: {
                                      parentCallBack: function(p) {
                                        _vm.trackingForm.trackingWtPriority.conditionFieldMedium =
                                          p.value
                                      }
                                    }
                                  }),
                                  _c(
                                    "div",
                                    { staticStyle: { "margin-top": "10px" } },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          staticStyle: {
                                            width: "65px",
                                            "margin-right": "5px"
                                          },
                                          attrs: {
                                            disabled: !_vm.priorityMediumEnable
                                          },
                                          model: {
                                            value:
                                              _vm.trackingForm
                                                .trackingWtPriority
                                                .triggerMethodMedium,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.trackingForm
                                                  .trackingWtPriority,
                                                "triggerMethodMedium",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "trackingForm.trackingWtPriority.triggerMethodMedium"
                                          }
                                        },
                                        [
                                          _c("el-option", {
                                            attrs: {
                                              value: 1,
                                              label: _vm.$t(
                                                "CargoMsg.Cargo_BringForward"
                                              )
                                            }
                                          }),
                                          _c("el-option", {
                                            attrs: {
                                              value: 2,
                                              label: _vm.$t(
                                                "CargoMsg.Cargo_Postpone"
                                              )
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c("el-input-number", {
                                        staticStyle: {
                                          width: "112px",
                                          "margin-left": "5px",
                                          "margin-right": "5px"
                                        },
                                        attrs: {
                                          disabled: !_vm.priorityMediumEnable,
                                          type: "number",
                                          oninput:
                                            "value=value.replace(/[^\\d]/g,'')",
                                          step: 1,
                                          controls: false
                                        },
                                        model: {
                                          value:
                                            _vm.trackingForm.trackingWtPriority
                                              .hourMedium,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.trackingForm
                                                .trackingWtPriority,
                                              "hourMedium",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "trackingForm.trackingWtPriority.hourMedium"
                                        }
                                      }),
                                      _c("span", [
                                        _vm._v(_vm._s(_vm.$t("Pricing.Hour")))
                                      ]),
                                      _c("el-input-number", {
                                        staticStyle: {
                                          width: "112px",
                                          "margin-left": "5px",
                                          "margin-right": "5px"
                                        },
                                        attrs: {
                                          disabled: !_vm.priorityMediumEnable,
                                          type: "number",
                                          min: 0,
                                          max: 59,
                                          step: 1,
                                          controls: false
                                        },
                                        model: {
                                          value:
                                            _vm.trackingForm.trackingWtPriority
                                              .minuteMedium,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.trackingForm
                                                .trackingWtPriority,
                                              "minuteMedium",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "trackingForm.trackingWtPriority.minuteMedium"
                                        }
                                      }),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.$t("SeaExport.Minute"))
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                [
                                  _c(
                                    "el-checkbox",
                                    {
                                      on: {
                                        change: function($event) {
                                          return _vm.priorityLowEnableChange()
                                        }
                                      },
                                      model: {
                                        value: _vm.priorityLowEnable,
                                        callback: function($$v) {
                                          _vm.priorityLowEnable = $$v
                                        },
                                        expression: "priorityLowEnable"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "CargoMsg.Cargo_HandlingPriorityMarkersLow"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "CargoMsg.Cargo_ConditionalItem"
                                        ) + ": "
                                      )
                                    )
                                  ]),
                                  _c("cargo-advance-select", {
                                    staticStyle: {
                                      "margin-left": "10px",
                                      width: "296px",
                                      display: "inline-block"
                                    },
                                    attrs: {
                                      disabled: !_vm.priorityLowEnable,
                                      "default-value":
                                        _vm.trackingForm.trackingWtPriority
                                          .conditionFieldLow,
                                      "static-options": _vm.priorityConditions,
                                      "tag-value": "code",
                                      filterable: "",
                                      "filter-type": "global",
                                      cache: false
                                    },
                                    on: {
                                      parentCallBack: function(p) {
                                        _vm.trackingForm.trackingWtPriority.conditionFieldLow =
                                          p.value
                                      }
                                    }
                                  }),
                                  _c(
                                    "div",
                                    { staticStyle: { "margin-top": "10px" } },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          staticStyle: {
                                            width: "65px",
                                            "margin-right": "5px"
                                          },
                                          attrs: {
                                            disabled: !_vm.priorityLowEnable
                                          },
                                          model: {
                                            value:
                                              _vm.trackingForm
                                                .trackingWtPriority
                                                .triggerMethodLow,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.trackingForm
                                                  .trackingWtPriority,
                                                "triggerMethodLow",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "trackingForm.trackingWtPriority.triggerMethodLow"
                                          }
                                        },
                                        [
                                          _c("el-option", {
                                            attrs: {
                                              value: 1,
                                              label: _vm.$t(
                                                "CargoMsg.Cargo_BringForward"
                                              )
                                            }
                                          }),
                                          _c("el-option", {
                                            attrs: {
                                              value: 2,
                                              label: _vm.$t(
                                                "CargoMsg.Cargo_Postpone"
                                              )
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c("el-input-number", {
                                        staticStyle: {
                                          width: "112px",
                                          "margin-left": "5px",
                                          "margin-right": "5px"
                                        },
                                        attrs: {
                                          disabled: !_vm.priorityLowEnable,
                                          type: "number",
                                          oninput:
                                            "value=value.replace(/[^\\d]/g,'')",
                                          step: 1,
                                          controls: false
                                        },
                                        model: {
                                          value:
                                            _vm.trackingForm.trackingWtPriority
                                              .hourLow,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.trackingForm
                                                .trackingWtPriority,
                                              "hourLow",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "trackingForm.trackingWtPriority.hourLow"
                                        }
                                      }),
                                      _c("span", [
                                        _vm._v(_vm._s(_vm.$t("Pricing.Hour")))
                                      ]),
                                      _c("el-input-number", {
                                        staticStyle: {
                                          width: "112px",
                                          "margin-left": "5px",
                                          "margin-right": "5px"
                                        },
                                        attrs: {
                                          disabled: !_vm.priorityLowEnable,
                                          type: "number",
                                          min: 0,
                                          max: 59,
                                          step: 1,
                                          controls: false
                                        },
                                        model: {
                                          value:
                                            _vm.trackingForm.trackingWtPriority
                                              .minuteLow,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.trackingForm
                                                .trackingWtPriority,
                                              "minuteLow",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "trackingForm.trackingWtPriority.minuteLow"
                                        }
                                      }),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.$t("SeaExport.Minute"))
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        2
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.trackingTemplateForm.workTaskEnable || _vm.isPlatform
                ? _c(
                    "el-card",
                    {
                      staticClass: "box-card",
                      staticStyle: { width: "468px" }
                    },
                    [
                      _c(
                        "el-form",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            disabled: _vm.readOnly,
                            "label-position": "left",
                            "label-width": "90px"
                          }
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "title",
                              attrs: {
                                title: _vm.$t(
                                  "SystemMaintenance.ServiceScenarioApplication"
                                )
                              }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "SystemMaintenance.ServiceScenarioApplication"
                                    )
                                  ) +
                                  " "
                              )
                            ]
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { "margin-left": "15px" },
                              attrs: {
                                label: _vm.$t(
                                  "SystemMaintenance.SettingApplicationScenarios"
                                )
                              }
                            },
                            [
                              _c("specific-business-rule-dialog", {
                                attrs: {
                                  width: "600px",
                                  lob: _vm.trackingForm.lob,
                                  "apply-sop-board": true,
                                  "specific-business-rule-uuid":
                                    _vm.trackingForm
                                      .trackingWtSpecificBusinessRule
                                      .specificBusinessRuleUuid,
                                  "specific-business-rules":
                                    _vm.specificBusinessRules
                                },
                                on: {
                                  change: function(p) {
                                    return _vm.specificBusinessRuleChange(
                                      p,
                                      _vm.trackingForm
                                        .trackingWtSpecificBusinessRule
                                    )
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { "margin-left": "15px" },
                              attrs: {
                                label: _vm.$t(
                                  "CargoMsg.Cargo_SetParameterValues"
                                )
                              }
                            },
                            [
                              _c("el-input", {
                                staticStyle: { width: "250px" },
                                attrs: {
                                  no: "ruleParam",
                                  type: "textarea",
                                  rows: 3
                                },
                                model: {
                                  value:
                                    _vm.trackingForm
                                      .trackingWtSpecificBusinessRule.ruleParam,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.trackingForm
                                        .trackingWtSpecificBusinessRule,
                                      "ruleParam",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "trackingForm.trackingWtSpecificBusinessRule.ruleParam"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "title",
                              staticStyle: { width: "100%" },
                              attrs: {
                                title: _vm.$t(
                                  "CargoMsg.Cargo_OperationButtonSettingsAndTip"
                                )
                              }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "CargoMsg.Cargo_OperationButtonSettingsAndTip"
                                    )
                                  ) +
                                  " "
                              ),
                              _c("i", {
                                staticClass: "el-icon-circle-plus",
                                staticStyle: {
                                  color: "#42b983",
                                  cursor: "pointer",
                                  position: "absolute",
                                  right: "35px",
                                  top: "-4px",
                                  "font-size": "18px"
                                },
                                on: { click: _vm.addTenantInstruction }
                              })
                            ]
                          ),
                          _vm._l(
                            _vm.trackingForm.trackingWtInstructions,
                            function(trackingWtInstruction, index) {
                              return _c(
                                "div",
                                {
                                  key: index,
                                  staticStyle: { "margin-left": "15px" }
                                },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "CargoMsg.Cargo_SelectInstruction"
                                        )
                                      }
                                    },
                                    [
                                      _c("tenant-instruction-dialog", {
                                        attrs: {
                                          width: "600px",
                                          lob: _vm.trackingForm.lob,
                                          "apply-sop-board": true,
                                          value:
                                            trackingWtInstruction.tenantInstructionUuid,
                                          "tenant-instructions":
                                            _vm.tenantInstructions
                                        },
                                        on: {
                                          change: function(p) {
                                            return _vm.tenantInstructionChange(
                                              p,
                                              trackingWtInstruction
                                            )
                                          }
                                        }
                                      }),
                                      _c("i", {
                                        staticClass: "el-icon-remove",
                                        staticStyle: {
                                          color: "#f56c6c",
                                          cursor: "pointer",
                                          position: "absolute",
                                          right: "35px",
                                          top: "5px",
                                          "font-size": "18px"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.deleteTrackingWtInstruction(
                                              index
                                            )
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "CargoMsg.Cargo_SetParameters"
                                        )
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        staticStyle: { width: "250px" },
                                        attrs: {
                                          no: "instructionParam",
                                          type: "textarea",
                                          rows: 3
                                        },
                                        model: {
                                          value:
                                            trackingWtInstruction.instructionParam,
                                          callback: function($$v) {
                                            _vm.$set(
                                              trackingWtInstruction,
                                              "instructionParam",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "trackingWtInstruction.instructionParam"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            }
                          )
                        ],
                        2
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ]
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "template-select-dialog",
          attrs: {
            visible: _vm.templateSelectDialog.visible,
            title: _vm.$t("SystemMaintenance.SelectSOPTemplateForNode"),
            width: "400px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.templateSelectDialog, "visible", $event)
            }
          }
        },
        [
          _c("cargo-ag-grid", {
            staticStyle: { height: "360px" },
            attrs: {
              "grid-options": _vm.templateSelectDialog.gridOptions,
              "row-data": _vm.templateSelectDialog.rowData,
              "show-side-bar": false
            }
          }),
          _c(
            "div",
            {
              staticStyle: { width: "100%", padding: "0 30px" },
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-checkbox",
                {
                  staticStyle: { float: "left" },
                  on: { change: _vm.onSelectAllChange },
                  model: {
                    value: _vm.templateSelectDialog.all,
                    callback: function($$v) {
                      _vm.$set(_vm.templateSelectDialog, "all", $$v)
                    },
                    expression: "templateSelectDialog.all"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Message.SelectAll")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "ok", type: "primary" },
                  on: { click: _vm.doTemplateSelect }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.ok")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "cancel" },
                  on: {
                    click: function($event) {
                      _vm.templateSelectDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }